import { OperationVariables } from "@apollo/client";
import {
  ErrorCode,
  LayoutNodeFilter,
  LayoutNodeFilterType,
  Product,
  ProductIdByStockNumberResult,
  StockNumberNotFoundError,
} from "@towersystems/roam-common/lib/generated-types";
import { minBy } from "lodash";

export const lowestPrice = <T extends Product>(
  product: T,
  variants: T[] = []
): number => {
  const allLocationInventoryPricing = [
    ...(product.locationInventoryPricing || []),
    ...variants.flatMap((v) => v.locationInventoryPricing),
  ];

  return minBy(allLocationInventoryPricing.map((i) => i.retailPrice)) || 0;
};

export function graphqlVariableFormatter(
  variables: OperationVariables,
  filter?: LayoutNodeFilter
) {
  const extraFilters = filter
    ? {
        [filterTypeToProductFilterMap[filter.type]]: {
          in: filter.values,
        },
      }
    : {};

  return {
    options: {
      ...variables,
      filter: {
        ...variables.filter,
        ...extraFilters,
      },
    },
  };
}

export const filterTypeToProductFilterMap = {
  [LayoutNodeFilterType.CATEGORY]: "categoryId",
  [LayoutNodeFilterType.DEPARTMENT]: "departmentId",
};

export const isStockNumberNotFoundError = (
  result: ProductIdByStockNumberResult
): result is StockNumberNotFoundError => {
  return (result as any)?.errorCode === ErrorCode.STOCK_NUMBER_NOT_FOUND_ERROR;
};
